import log from 'loglevel';
import prefix from 'loglevel-plugin-prefix';
export const buildProdClientLogger = () => {
    log.setLevel(log.levels.INFO);
    prefix.reg(log);
    prefix.apply(log);
    return log;
};
